export const MINIMUM_DEBOUNCE_INTERVAL = 16
